import type { FaireProductEntity } from "../../entity_types/product";

export const p_ap76jjw6vs: FaireProductEntity = {
  token: "p_ap76jjw6vs",
  type: "product",
  name: "Nutcracker Season 100 Piece Christmas Puzzle Snax",
  brandToken: "b_4l0np8cc8r",
  brandName: "WerkShoppe",
  imageUrl:
    "https://cdn.faire.com/fastly/05dff00418625e8c5c43a33c9bc1dc1add9b90ddac04ac093c3e44c2c7c74683.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/65de296c6fdd95f41045b5c14478e0052e68753758d2efcc3d62c1c94c4e2115.jpeg",
    "https://cdn.faire.com/fastly/c8771900e198010e475585ed81dcb4a71c9c284bbc355e59862b4fdcd6996ae2.jpeg",
    "https://cdn.faire.com/fastly/90fe678b2fcce6fb12cf86fb78d4d179e00ed3825e9780aae896195949259389.jpeg",
  ],
  priceDollars: 5.5,
  description:
    'Strike up the ballet, the Nutcracker Season Puzzle Snax is here. This vibrant 100-piece puzzle features three magnificently dressed nutcracker soldiers framed by garlands, berries, and holiday greenery, all finished with gold foil accents that catch the light beautifully.\n\nBold, colorful, and full of festive personality, it\'s a quick and satisfying puzzle tucked into a resealable pouch and finished at 8" x 10". A charming seasonal gift that feels as special as the holiday itself.\n\nProduct Details\n\n * 100 piece jigsaw puzzle \n * Limited edition puzzle embellished with gold foil \n * Assembled puzzle size: 8" W x 10" H \n * 100% recycled board & non-toxic vegetable-based ink \n * Ribbon cut pieces \n * Package: resealable pouch \n * Recommended age: 7+ years \n\nArt by Kenzie Kae Elston\n',
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:26.680Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
